/**
 * Mensagem do backend para mostrar ao usuário. O backend responde de vários jeitos:
 *  - texto puro (BadRequest(ex.Message), inclusive os Hard Stops SOX com a orientação de como resolver);
 *  - { message } / { mensagem } / { error } / { detail } / { title };
 *  - ProblemDetails de validação: { errors: { Campo: ["erro"] } }.
 * Sem nenhuma mensagem útil, usa o texto padrão da tela.
 */
export const extrairMensagemErro = (err: any, fallback: string): string => {
  const data = err?.response?.data;
  if (typeof data === 'string') {
    const t = data.trim();
    // Página HTML de erro do servidor não ajuda o usuário.
    if (t && !t.startsWith('<')) return t;
  }
  if (data && typeof data === 'object') {
    for (const chave of ['message', 'mensagem', 'error', 'detail']) {
      const v = (data as any)[chave];
      if (typeof v === 'string' && v.trim()) return v.trim();
    }
    const erros = (data as any).errors;
    if (erros && typeof erros === 'object') {
      const lista = Object.values(erros).flat().filter((x): x is string => typeof x === 'string' && x.trim() !== '');
      if (lista.length > 0) return lista.join(' ');
    }
    if (typeof (data as any).title === 'string' && (data as any).title.trim()) return (data as any).title.trim();
  }
  if (err?.response?.status === 403) return 'Você não tem permissão para realizar esta ação.';
  return fallback;
};
